import { Hero } from "../components/home/Hero";
import { TrustBar } from "../components/TrustBar";
import { Intro } from "../components/home/Intro";
import { Services } from "../components/home/Services";
import { Projects } from "../components/home/Projects";
import { BeforeAfter } from "../components/home/BeforeAfter";
import { WhyCando } from "../components/home/WhyCando";
import { Process } from "../components/home/Process";
import { Edmonton } from "../components/home/Edmonton";
import { Faq } from "../components/home/Faq";
import { FinalCta } from "../components/home/FinalCta";

export default function HomePage() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TrustBar />
      <Intro />
      <Services />
      <Projects />
      <BeforeAfter />
      <WhyCando />
      <Process />
      <Edmonton />
      <Faq />
      <FinalCta />
    </main>
  );
}
